export const AUTOSAVE_INTERVAL_MS = 1000
export const GANTT_CHART_ROW_HEIGHT = 50
export const GANTT_CHART_STEPS_PER_HOUR = 1 as const
export const NOW_INDICATOR_REFRESH_INTERVAL_MS = 60 * 1000
export const ONE_MINUTE_REFRESH_INTERVAL = 60 * 1000
export const SLIDER_ROUND_TO_INTERVAL_HOURS = 12

export const OPTIMIZER_DEFAULT_RANGE_DAYS = 8

export const LONG_TERM_PLANNING_DAYS = 31
